import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import { Classification, ClassificationData, Classifications } from './classification';
import { ConfigService } from '@docma-mm-core/config/config.service';

const savedProjectClassificationsKey: string = 'mm-savedProjectClassifications';

@Injectable()
export class ClassificationService extends BasedataService {

  private projectUrl: string = '/projects/';
  private classificationUrl: string = '/classifications';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectClassificationUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.classificationUrl);
  }

  private getClassificationUrl() {
    return super.getFullUrl(this.classificationUrl);
  }



  // get classifications
  getClassifications(): Observable<Classifications> {
    let endpoint = this.getClassificationUrl();
    return this.http
      .get<Classifications>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // get classifications by project
  getProjectClassifications(projectId: number): Observable<Classifications> {
    let endpoint = this.getProjectClassificationUrl(projectId);
    return this.http
      .get<Classifications>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // get classification by type [class1, class2, class3, class4]
  getClassificationsByType(type: string, top: number = 1000, skip: number = 0): Observable<ClassificationData> {
    let endpoint = this.getClassificationUrl();
    let httpParams = new HttpParams();
    httpParams = httpParams.set('type', type);
    if (top) httpParams = httpParams.set('$top', top.toString());
    if (skip) httpParams = httpParams.set('$skip', skip.toString());
    return this.http
      .get<ClassificationData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // create new classification by type
  createClassification(type: string, classification: Classification): Observable<Classification> {
    let endpoint = this.getClassificationUrl();
    let httpParams = new HttpParams();
    httpParams = httpParams.set('type', type);
    return this.http
      .post<Classification>(endpoint, JSON.stringify(classification), { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // update existing classification by type
  updateClassification(type: string, classification: Classification): Observable<Classification> {
    let endpoint = this.getClassificationUrl();
    let httpParams = new HttpParams();
    httpParams = httpParams.set('type', type);
    return this.http
      .put<Classification>(endpoint, JSON.stringify(classification), { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // delete classification by id and type
  deleteClassification(classificationId: number, classificationUid: string, type: string): Observable<any> {
    let endpoint = this.getClassificationUrl();
    let httpParams = new HttpParams();
    httpParams = httpParams.set('id', classificationId.toString());
    httpParams = httpParams.set('uid', classificationUid);
    httpParams = httpParams.set('type', type);
    return this.http
      .delete<any>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
